export const USER_TYPE_STAFF = 'staff';
export const USER_TYPE_CRM = 'crm';

export default {
  USER_TYPE_CRM,
  USER_TYPE_STAFF,
};
